/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { BankIcon } from 'components/elements';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function BankDetails({ bankName, institutionNumber, last4, isDefault, transitNumber, name: cardHolder }) {
  const classes = useStyles(Styles);
  const { t } = useTranslation('labels');

  return (
    <div className={classes.bankDetailsWrapper}>
      <div className={classes.brandIconWrapper}>
        <BankIcon />
      </div>
      <Typography data-testid="bankInfoText" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }} color="text.secondary" variant="body2" component="span">
        {`${bankName} ****${last4} (${institutionNumber}-${transitNumber}) ${cardHolder}`}
      </Typography>
      <p className={classes.defaultBank}>{isDefault ? `( ${t('stripe_default')} )` : null}</p>
    </div>
  );
}

BankDetails.propTypes = {
  bankName: PropTypes.string,
  institutionNumber: PropTypes.string,
  transitNumber: PropTypes.string,
  last4: PropTypes.string,
  name: PropTypes.string,
  isDefault: PropTypes.bool,
};

BankDetails.defaultProps = {
  bankName: '',
  institutionNumber: '',
  transitNumber: '',
  last4: '',
  name: '',
  isDefault: false,
};

export default BankDetails;
